import { permPlacementDetailsRoutes } from './features/perm-placement-details/perm-placement-details.routes';
import { permPlacementsListingRoutes } from './features/perm-placements-listing/perm-placements-listing.routes';

export const permPlacementsRoutes = [
  {
    path: '/perm-placements',
    name: 'perm-placements',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "perm-placements" */ './PermPlacements.vue'),
    children: [
      {
        path: 'batch-update',
        name: 'perms-batch-update',
        component: () =>
          import(/* webpackChunkName: "time-sheet-batch-update" */ '../../features/batch-update/BatchUpdateListing.vue')
      },
      ...permPlacementsListingRoutes,
      ...permPlacementDetailsRoutes
    ]
  }
];
